export const GRAPHQL_ENDPOINT = "/api/vaults/graphql";
